import React, { useState/*, useEffect, useRef*/ } from 'react';
import CKEditor from "react-ckeditor-component";

export default function ASSEC_CKEditor(props) {

    const [ck_content, set_ck_content] = useState(props.content)

    const onChange = (evt) => {
        //console.log("onChange1 :", props.func);

        //console.log("onChange fired with event info: ", evt);
        var newContent = evt.editor.getData();
        //console.log("onChange2 :", newContent);
        //props.func(newContent)
        //set_ck_content(newContent)
        //console.log("onChange3 :", newContent);

        set_ck_content(newContent)
        props.func(newContent)

    }

    return (
        <div>
            <CKEditor
                activeClass="p10"
                content={ck_content}
                events={{
                    "change": onChange,
                    //"dialogShow": (e) => targetBlank(e),
                }}
                //scriptUrl="https://cdn.ckeditor.com/4.6.2/standard-all/ckeditor.js"
                //scriptUrl="https://cdn.ckeditor.com/4.6.2/full-all/ckeditor.js"
                //scriptUrl="https://cdn.ckeditor.com/4.6.2/full/ckeditor.js"
                //scriptUrl="https://cdnjs.cloudflare.com/ajax/libs/ckeditor/4.6.2/ckeditor.js"
                scriptUrl="https://cdn.assec.app/repo/ckeditor/ckeditor.js"
                config={{
                    toolbar: [ 
                        ['Source'],
                        ['Cut','Copy','Paste','PasteText','PasteFromWord','-','Print', /*'SpellChecker', 'Scayt'*/],
                        ['Undo','Redo','-','Find','Replace','-','SelectAll','RemoveFormat'],
                        ['Link','Unlink','Anchor'],
                        ['Maximize', 'ShowBlocks'  ],
                        '/',
                        ['Styles'], 
                        ['Bold','Italic','Underline','Strike','-','Subscript','Superscript'],
                        ['NumberedList','BulletedList','-','Outdent','Indent','Blockquote'],
                        ['JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock'], 
                        ['Table','HorizontalRule' ,'SpecialChar'],
                    ],
                    stylesSet: [
                        {name : 'Título', element : 'span', attributes: {'class': 'titulo-primario'} },
                        {name : 'Título 2', element : 'span', attributes: {'class': 'titulo-secundario'} },
                        {name : 'Subtítulo', element : 'span', attributes: {'class': 'subtitulo-primario'} },
                        {name : 'Subtítulo 2', element : 'span', attributes: {'class': 'subtitulo-secundario'} },
                        {name : 'Maiúsculas', element : 'span', attributes: {'class': 'maiusculas'} },
                        //{name : 'Latim', element : 'span', attributes: {'class': 'latim'} },
                        {name : 'Legenda', element : 'span', attributes: {'class': 'legenda'} }
                    ],
                    contentsCss: [
                        './ckeditor.css',
                    ],
                    allowedContent: true,
                    ignoreEmptyParagraph : false,
                    fillEmptyBlocks : false,
                    //removePlugins: 'scayt',
                    //language: 'pt',
                    //height: '300px',
                    //extraPlugins: 'autogrow',
                    //autoGrow_onStartup: true,
                    //autoGrow_minHeight: 200,
                    //autoGrow_maxHeight: 600,
                    //autoGrow_bottomSpace: 50,
                }}
            />
        </div>
    )


}


/*
// EXMEPLO DE UTILIZAÇÃO
    <ASSEC_CKEditor
        name={"text-" + k}
        content={el_lang.id === '1' ? el.text : get_value_content_lang(k, el_lang.id, 'text')}
        func={(e) => handle_change_content_ckeditor(e, k, el_lang.id, el_lang.code, 'text')}
    />
*/

